/**
 * Checks for the length of an object and returns true or false
 */
export const isEmpty = (obj) => !Object.keys(obj).length;